import { computed, inject, Injectable, signal } from '@angular/core';
import { _HttpClient, SettingsService } from '@delon/theme';
import { FcwidgetService } from '../../../core/util/fcwidget.service';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root'
})
export class QbotWidgetService {
  #http = inject(_HttpClient);
  #router = inject(Router);
  #msg = inject(NzMessageService);
  showReportAnalyzerWidget = signal(false);
  showReportDesignerWidget = signal(false);

  selectedTopPick = signal<string | null>(null);

  settingsService = inject(SettingsService);

  company = signal(this.settingsService.user['company']);

  showNotificationLayout = signal(false);
  notificationIsClosed = signal(true);

  invalidLicence = computed(() => {
    const company: any = this.company();
    return !!company?.isSample || !!company?.isFreeTrial;
  });

  upgradeFromAiLayouts(reloadLayout: boolean = false){
    if (!this.company().isOwner && !this.company()?.isSample) {
      this.#msg.warning(
        'Only the owner of the company can subscribe to premium features.'
      );
      return;
    }

    let url = `/account/subscription/subscribe/${this.company()['tenantId']}`;
    if(this.company()?.isSample){
      url = '/account/companies/sample'
    }
    if(!reloadLayout){
      this.#router.navigateByUrl(url);
    }else{
      this.#router.navigateByUrl(url).then(() => {
        window.location.reload();
      });
    }
  }

  openAiAssistant(fcWidget: FcwidgetService) {
    const chatbot = document.getElementById('chatbot-window');
    if (chatbot?.classList.contains('visible')) {
      chatbot.classList.toggle('visible');
    }
    fcWidget.openWithUserContext();
  }
}
